import { FC, memo, useCallback, useContext, useRef, useLayoutEffect } from 'react'
import styles from 'components/features/pfm/NotificationTray/NotificationTrayButton.styl'
import cn from 'classnames'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'
import BellIcon from 'icons/bell.svg'
import SvgIcon from 'components/atoms/SvgIcon'
import { NotificationTrayContext } from 'components/features/pfm/NotificationTray/NotificationTrayContextProvider'

type NotificationTrayButtonProps = {}

export const NotificationTrayButton: FC<NotificationTrayButtonProps> = memo(() => {

  const { buttonProps, onButtonRootRef } = useContext(NotificationTrayContext)
  const rootRef = useRef<HTMLButtonElement>(null)

  const handleClick = useCallback(() => {
    if (!buttonProps || !buttonProps.onClick) {
      return
    }
    buttonProps.onClick()
  }, [buttonProps])

  useLayoutEffect(() => {
    onButtonRootRef(rootRef)
  })

  if (!buttonProps) {
    return null
  }

  const { counter, isExpanded } = buttonProps

  const bellClassName = cn(styles.bell, {
    [styles.isZero]: !counter,
  })

  const counterClassName = cn(styles.counter, {
    [styles.expanded]: isExpanded,
  })

  const counterChild = (
    <div className={ counterClassName }>
      <span className={ styles.counterValue }>{ counter }</span>
      <div className={ styles.cross } />
    </div>
  )

  return (
    <AnalyticsClick
      category='site_controls-notification_tray'
      action='click-expand_tray-bell'
    >
      <button
        ref={ rootRef }
        className={ bellClassName }
        onClick={ handleClick }
        title={ isExpanded ? 'Hide Alerts' : 'Show Alerts' }
      >
        <SvgIcon src={ BellIcon } />
        { counterChild }
      </button>
    </AnalyticsClick>
  )
})
